<template>
  <div cstyle="height: 100%" class="column no-wrap">
    <sample-info-card
      v-if="sample && sample.detail"
      class="q-ma-md"
      :sampleDetail="sample.detail"
    />
    <div class="q-mx-md">
      <q-btn flat rounded color="gray" :to="{ name: 'member-sample-detail' }">
        <q-icon
          style="font-size: 13px"
          name="fas fa-arrow-left"
          class="q-mr-sm"
        />
        <span style="font-size: 13px">返回</span>
      </q-btn>
    </div>

    <div class="row justify-center">
      <h5 class="text-secondary text-bold q-ma-md">请确认样本状态，开始调查</h5>
      <q-btn
        flat
        class="bg-secondary q-ma-md text-white rounded-borders"
        :to="{
          name: 'member-questionnaire',
          params: {
            sample_id: $route.params.sample_id,
          },
        }"
        :style="{
          width: '70%',
        }"
        :disable="isRejected || isNotFind || isSubmitted"
      >
        {{
          isRejected
            ? "样本已锁定（样本拒访）"
            : isNotFind
            ? "样本已锁定（无法找到的样本）"
            : isSubmitted
            ? "样本已提交（问卷已提交）"
            : "开始调查"
        }}
      </q-btn>
      <div style="width: 70%" class="row justify-between">
        <q-btn
          flat
          class="bg-indigo-9 text-white rounded-borders"
          :style="{
            width: '45%',
          }"
          :disable="isRejected || isNotFind || isSubmitted"
          @click="showNotFindDialog = true"
        >
          {{
            isRejected
              ? "样本已锁定"
              : isNotFind
              ? "已标记无法找到样本"
              : isSubmitted
              ? "问卷已提交"
              : "无法找到样本"
          }}
        </q-btn>
        <q-btn
          v-if="!canMarkRejected"
          flat
          class="bg-indigo-9 text-white rounded-borders"
          :style="{
            width: '45%',
          }"
          @click="showRefuseDialog = true"
          :disable="isNotFind || isSubmitted"
        >
          {{
            isNotFind
              ? "已标记无法找到样本"
              : isSubmitted
              ? "问卷已提交"
              : "样本拒访"
          }}
        </q-btn>
        <q-btn
          v-if="canMarkRejected"
          flat
          class="bg-indigo-9 text-white rounded-borders"
          :style="{
            width: '45%',
          }"
          @click="showRefuseCheckDialog = true"
          :disable="isRejected || isNotFind || isSubmitted"
        >
          {{
            isRejected
              ? "已标记拒访"
              : isNotFind
              ? "已标记"
              : isSubmitted
              ? "已提交"
              : "标记为拒访样本"
          }}
        </q-btn>

        <!-- 拒访记录表单 -->
        <q-dialog v-model="showRefuseDialog">
          <q-card class="q-pa-md" style="width: 500px">
            <q-card-section class="row items-center q-pb-none">
              <div class="text-h6">请记录拒访信息</div>
              <q-space />
              <q-btn icon="fas fa-times" flat round dense v-close-popup />
            </q-card-section>
            <p class="q-ma-md text-bold">请在下方输入本次拒访原因</p>
            <q-input
              class="q-mt-lg"
              v-model="rejectedReslut"
              filled
              clearable
              autofocus
              dense
              color="primary"
              type="textarea"
            />
            <q-file
              dense
              v-model="file"
              label="添加一些备注图片(如果需要)"
              outlined
              color="primary"
              class="q-mt-md"
            >
            </q-file>

            <q-btn
              @click="submit"
              flat
              class="bg-primary full-width text-white q-mt-md"
              :disable="rejectedReslut===''"
            >
              <q-icon name="fas fa-envelope-open-text q-mr-sm" size="0.8rem" />
              <span>提交</span>
            </q-btn>
            <q-card-section> </q-card-section>
          </q-card>
        </q-dialog>

        <!-- 拒访状态确认 -->
        <q-dialog v-model="showRefuseCheckDialog">
          <q-card class="bg-indigo-9 text-white" style="width: 300px">
            <q-card-section v-if="sample.detail">
              <div class="text-subtitle1">
                请确认，是否标将<strong>{{ sample.detail.name }}</strong
                >标记为拒访样本
              </div>
            </q-card-section>

            <q-card-section class="q-pt-none">
              确认后，您或组长都无法再次进行修改或是调整，需要联系管理员进行修改。
              请选择确认或取消
            </q-card-section>

            <q-card-actions align="right" class="bg-white text-white">
              <q-btn flat class="text-indigo-9" label="取消" v-close-popup />

              <q-btn
                outline
                class="bg-indigo-9"
                label="确认"
                @click="markedRejected"
              />
            </q-card-actions>
          </q-card>
        </q-dialog>

        <!-- 找不到的样本确认 -->
        <q-dialog v-model="showNotFindDialog">
          <q-card class="q-pa-md" style="width: 500px">
            <q-card-section class="row items-center q-pb-none">
              <div class="text-subtitle1">
                请简要描述情况，以便后台质控人员进行信息核实
              </div>
              <q-space />
              <q-btn icon="fas fa-times" flat round dense v-close-popup />
            </q-card-section>
            <q-input
              class="q-mt-lg"
              v-model="notFindReslut"
              filled
              clearable
              autofocus
              dense
              color="primary"
              type="textarea"
            />
            <q-file
              dense
              v-model="file"
              label="添加一些备注图片(如果需要)"
              outlined
              color="primary"
              class="q-mt-md"
            >
            </q-file>
            <q-btn
              flat
              class="bg-primary full-width text-white q-mt-md"
              @click="showNotFindCheckDialog = true"
              :disable="notFindReslut===''"
            >
              <q-icon name="fas fa-envelope-open-text q-mr-sm" size="0.8rem" />
              提交
            </q-btn>
          </q-card>
        </q-dialog>

        <!-- 无法找到确认 -->
        <q-dialog v-model="showNotFindCheckDialog">
          <q-card class="bg-indigo-9 text-white" style="width: 300px">
            <q-card-section v-if="sample.detail">
              <div class="text-subtitle1">
                请确认，是否标将<strong>{{ sample.detail.name }}</strong
                >标记无法找到
              </div>
            </q-card-section>

            <q-card-section class="q-pt-none">
              确认后，您或组长都无法再次进行修改或是调整，需要联系管理员进行修改。
              请选择确认或取消
            </q-card-section>

            <q-card-actions align="right" class="bg-white text-white">
              <q-btn flat class="text-indigo-9" label="取消" v-close-popup />

              <q-btn
                outline
                class="bg-indigo-9"
                label="确认"
                @click="submitNotFind"
              />
            </q-card-actions>
          </q-card>
        </q-dialog>
      </div>
    </div>
    <!-- 拒访原因列表 -->
    <div class="q-ma-md q-pa-sm">
      <div v-if="sample.detail" class="q-pa-sm q-mx-lg">
        <q-item-label
          v-if="
            rejectedList.filter((item) => {
              return !item.if_not_find;
            }).length > 0
          "
          header
        >
          拒访情况
        </q-item-label>
        <q-expansion-item
          v-for="(rejected, index) in rejectedList.filter((item) => {
            return !item.if_not_find;
          })"
          :key="index"
          icon="fas fa-city"
          :label="`样本：${sample.detail.name}，第${index + 1}次拒访问`"
          caption="查看具体原因"
        >
          {{ rejected.rejected_content }}
          <div
            v-if="
              rejected.rejected_image_url &&
              rejected.rejected_image_url.length > 0
            "
          >
            <q-img
              v-for="(img_url, img_index) in rejected.rejected_image_url"
              :key="img_index"
              :src="img_url"
              style="max-width: 400px; height: 200px"
              contain
            />
          </div>
        </q-expansion-item>
      </div>
    </div>

    <div class="row justify-center items-center fixed-bottom q-pa-md">
      <div class="full-width row items-center justify-center">
        <q-btn
          outline
          class="q-pd-md text-primary rounded-borders"
          :to="{ name: 'member-index' }"
        >
          <q-icon name="fas fa-arrow-left" class="q-mr-md" size="1rem" />
          回到样本详情页
        </q-btn>
      </div>

      <div
        class="
          row
          justify-center
          items-center
          q-pa-md q-mt-md
          bg-secondary
          full-width
          text-white text-bold
        "
      >
        拒访3次后，可以标记为拒访样本
      </div>
    </div>
  </div>
</template>
<script>
import UserDetailMixin from "../user-detail.mixin";
import { updateRejectSampleAttachment } from "../../../api/endpoints/rejected-sample/updateRejectedSampleAttachment";
import { createRejectedSample } from "../../../api/endpoints/rejected-sample/createRejectedSample";
import { createNotFindSample } from "../../../api/endpoints/rejected-sample/createNotFindSample";
import { getRejectedList } from "../../../api/endpoints/rejected-sample/getRejectedSample";
import { updateSampleStatusRejected } from "../../../api/endpoints/sample/updateSampleStatusRejected";
import { EventBus } from "@/bus";
import { SAMPLE_INFO_CHANGED } from "@/bus/member.events";

export default {
  mixins: [UserDetailMixin],
  components: {
    SampleInfoCard: () => import("../components/SampleInfoCard.vue"),
  },
  data() {
    return {
      sample: {},
      showRefuseDialog: false,
      showRefuseCheckDialog: false,
      showNotFindDialog: false,
      showNotFindCheckDialog: false,
      rejectedReslut: "",
      notFindReslut: "",
      file: null,
      rejectedList: [],
      attachmentUrl: [],
      canMarkRejected: false,
      // isRejected: false,
    };
  },
  computed: {
    isRejected() {
      return this.sample.sample_status === 3;
    },
    isNotFind() {
      return this.sample.sample_status === 4;
    },
    isSubmitted() {
      return this.sample.sample_status === 0;
    },
  },

  watch: {
    userDetail: {
      immediate: true,
      handler() {
        if (this.userDetail) {
          this.sample = this.userDetail.samples.find((sample) => {
            return sample.id === this.$route.params.sample_id;
          });
        }
      },
    },
    sample: {
      immediate: true,
      handler() {
        if (this.sample.id) {
          this.getRejected();
        }
      },
    },
    rejectedList: {
      immediate: true,
      handler() {
        if (this.rejectedList.length >= 3) {
          this.canMarkRejected = true;
        }
      },
    },
  },

  methods: {
    async upload() {
      const form = new FormData();
      form.append("file", this.file);
      try {
        const response = await updateRejectSampleAttachment(form);
        this.attachmentUrl.push(response.toString());
        if (response.status || response.error) {
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
          // done = false;
          // progress.error = true;
        } else {
          this.$q.notify({
            type: "success",
            message: "附件上传完成",
          });
          // this.isUploaded = true;
        }
      } catch (error) {
        this.$q.notify({
          type: "danger",
          message: error.toString(),
        });
      }
    },

    async submit() {
      if (this.file) {
        this.attachmentUrl = [];
        await this.upload();
        this.file = null;
      }
      if (this.rejectedReslut === "") {
        this.$q.notify({
          type: "danger",
          message: "请填写详细原因后再尝试提交",
        });
      }

      try {
        const info = {
          rejected_content: this.rejectedReslut,
          rejected_image_url: this.attachmentUrl,
        };
        const response = await createRejectedSample(info, this.sample.id);
        if (response.status || response.error) {
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
        } else {
          this.$q.notify({
            type: "success",
            message: "信息提交成功",
          });
          EventBus.$emit(SAMPLE_INFO_CHANGED);
          this.rejectedReslut = ""
        }
      } catch (error) {
        this.$q.notify({ type: "danger", message: "出现网络错误" });
      }

      this.showRefuseDialog = false;
    },

    async submitNotFind() {
      if (this.file) {
        this.attachmentUrl = [];
        await this.upload();
        console.log(this.attachmentUrl)
        this.file = null;
      }
      try {
        const info = {
          rejected_content: this.notFindReslut,
          rejected_image_url: this.attachmentUrl,
        };
        const response = await createNotFindSample(info, this.sample.id);
        if (response.status || response.error) {
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
        } else {
          this.$q.notify({
            type: "success",
            message: "信息提交成功",
          });
          this.showNotFindDialog = false;
          this.showNotFindCheckDialog = false;
          EventBus.$emit(SAMPLE_INFO_CHANGED);
          this.$forceUpdate();
        }
      } catch (error) {
        this.$q.notify({ type: "danger", message: "出现网络错误" });
      }
    },

    async getRejected() {
      try {
        const response = await getRejectedList(this.sample.id);
        if (response.status || response.error) {
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
        } else {
          console.log(response);
          this.rejectedList = response.sort((a, b) => {
            console.log(a.timestamp.createdAt);
            return (
              new Date(a.timestamp.createdAt) - new Date(b.timestamp.createdAt)
            );
          });
        }
      } catch (error) {
        this.$q.notify({ type: "danger", message: "获取拒访情况失败" });
      }
    },

    async markedRejected() {
      try {
        const response = await updateSampleStatusRejected(this.sample.id);
        if (response.status || response.error) {
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
        }
        this.showRefuseCheckDialog = false;
        //
        // 需要更新状态
        //
        EventBus.$emit(SAMPLE_INFO_CHANGED);
        this.$forceUpdate();
      } catch (error) {
        this.$q.notify({ type: "danger", message: "标记为拒访状态失败" });
      }
    },
  },
};
</script>